import { NotificationManager } from '../../services/notificationManager';
import LinkHandler from './linkHandler';
import { Platform } from 'react-native';

export const notificationOptions = {
  disableOnce: false,
};

export default class NotificationNavigator {
  linkHandler = new LinkHandler();
  notificationManager: NotificationManager;
  notificationParser;
  
  state = {
    link: undefined,
    // TODO: fix this hack (please dont judge me)
    message: Platform.OS == 'web' ? {} : undefined,
    autoNavigate: undefined,
  };

  constructor(notificationParser) {
    this.notificationParser = notificationParser;
  }

  setFields(notificationManager: NotificationManager, setCallback: any) {
    this.notificationManager = notificationManager;
    this.setAutoNavigateCallback = setCallback;
  }

  setup(notificationManager: NotificationManager, setCallback: any) {
    this.setFields(notificationManager, setCallback);

    if (notificationOptions.disableOnce) {
      console.log('[NotificationNavigator] disableOnce is set, ignoring auto launch and resetting');
      notificationOptions.disableOnce = false;
      this.state.link = false;
      this.state.message = false;
      this.setAutoNavigate(null);
      return;
    }

    this.linkHandler.setupInitialLinkHandler((url: string, autoNavigate: any) => {
      console.log('[NotificationNavigator] initial link ready');
      this.state.link = autoNavigate || false;
      this.setAutoNavigate(autoNavigate || this.state.autoNavigate);
    });
    this.notificationParser.setup((message: any, autoNavigate: any) => {
      console.log('[NotificationNavigator] notification ready');
      this.state.message = autoNavigate || false;
      this.setAutoNavigate(autoNavigate || this.state.autoNavigate);
    });
  }

  listenForEvents(notificationManager: NotificationNavigator, setCallback: any) {
    this.setFields(notificationManager, setCallback);

    this.state.message = 'skipped';

    console.log('[NotificationNavigator] setup listening for events');
    this.linkHandler.setupListener((url: string, autoNavigate: any) => {
      console.log('[NotificationNavigator] got url from event (after launched)');
      this.state.link = autoNavigate || false;
      this.setAutoNavigate(autoNavigate || this.state.autoNavigate);
    });
    this.notificationParser.setupNotificationOpenedEvent((message: any, autoNavigate: any) => {
      console.log('[NotificationNavigator] got a notification from event (after launched)');
      this.state.message = autoNavigate || false;
      this.setAutoNavigate(autoNavigate || this.state.autoNavigate);
    });
  }

  setAutoNavigate(autoNavigate) {
    console.log('[NotificationNavigator] set', autoNavigate);
    this.state.autoNavigate = autoNavigate;
    this.setAutoNavigateCallback(this.state.autoNavigate);
  }

  isReady() {
    if (this.state.link === undefined) {
      console.log('[NotificationNavigator] waiting for initialUrl');
      return false;
    } else if (this.state.message === undefined) {
      console.log('[NotificationNavigator] waiting for initialNotification');
      return false;
    } else if (this.state.autoNavigate && !this.state.autoNavigate.ready) {
      console.log('[NotificationNavigator] waiting for data before navigating');
      this.checkIfNotificationDataIsReady();
      return false;
    }

    console.log('[NotificationNavigator] ready');
    return true;
  }

  checkIfNotificationDataIsReady = async (): Promise<boolean> => {
    const next = await this.checkIfDataIsReady();
    this.setAutoNavigate(next);
    return next !== null;
  }

  checkIfDataIsReady = async (): Promise<any|null> => {
    if (!this.state.autoNavigate) {
      console.log('[NotificationNavigator] notification settings not set, nothing to check');
      return null;
    }

    if (this.state.autoNavigate.type === 'notification') {
      return this.getReadyNotificationState();
    } else if (this.state.autoNavigate.type === 'subscription') {
      // nothing to load, so always ready
      return {
        type: 'subscription',
        ready: true,
      };
    } else if (this.state.autoNavigate.type === 'auth') {
      // just launching the app, so always ready
      return {
        ... this.state.autoNavigate,
        ready: true,
      };
    } else {
      console.log('[InitialPushLink:Navigator] unknown navigate type', this.state.autoNavigate);
      return null;
    }
  }

  getReadyNotificationState = async (): Promise<any|null> => {
    const id = this.state.autoNavigate.id;

    if (id === 'abc') {
      const first = await this.notificationManager.getFirstNotification();
      if (first) {
        console.log('[NotificationNavigator] using first notification', first);
        return {
          id: first.id,
          type: 'notification',
          ready: true,
        };
      }
    }

    const isNotificationPresent = await this.notificationManager.isNotificationPresent(id);
    if (isNotificationPresent) {
      console.log('[NotificationNavigator] notification is ready', id);
      return {
        id,
        type: 'notification',
        ready: true,
      };
    } else {
      console.log('[NotificationNavigator] got invalid notification id, will not navigate');
      return null;
    }
  };

  cleanup() {
    if (this.notificationParser) {
      this.notificationParser.cleanup();
    }
    this.linkHandler.cleanup();
  }
}
